import * as React from "react";
import axios from "axios";
import dayjs from "dayjs";
import { useTheme } from "@mui/material/styles";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Label,
  ResponsiveContainer,
} from "recharts";
import Title from "../Layout/Title";
import * as Constants from "../../Constants";
import Cookies from 'universal-cookie';
const cookies = new Cookies()

// Generate Calculations Data
function createData(time, amount) {
  return { time, amount };
}

const data = [
  createData(dayjs().subtract(7, "day").format("DD/MM/YYYY"), 0),
  createData(dayjs().subtract(6, "day").format("DD/MM/YYYY"), 300),
  createData(dayjs().subtract(5, "day").format("DD/MM/YYYY"), 600),
  createData(dayjs().subtract(4, "day").format("DD/MM/YYYY"), 800),
  createData(dayjs().subtract(3, "day").format("DD/MM/YYYY"), 1500),
  createData(dayjs().subtract(2, "day").format("DD/MM/YYYY"), 2000),
  createData(dayjs().subtract(1, "day").format("DD/MM/YYYY"), 2400),
];

export default function Chart() {
  const theme = useTheme();
  const [calcs, setCalcs] = React.useState([]);

  React.useEffect(() => {
    axios.get(`${Constants.API_URL}/recentCalcs`, {
    params: { 
        logged_in : cookies.get('logged_in')
      }
    }, { withCredentials: true }).then((res) => {
      const onlyCalcs = res.data.logs.filter((log) => {
        return (
          log["action"] == "use_licence" &&
          log["error"] == "N" &&
          dayjs(log["timestamp"]) > dayjs().subtract(7, "day")
        );
      });
      setCalcs([
        {
          time: dayjs().subtract(7, "day").format("DD/MM/YYYY"),
          amount: onlyCalcs.filter((calc) => {
            return (
              dayjs().subtract(6, "day") > dayjs(calc["timestamp"]) &&
              dayjs(calc["timestamp"]) > dayjs().subtract(7, "day")
            );
          }).length,
        },
        {
          time: dayjs().subtract(6, "day").format("DD/MM/YYYY"),
          amount: onlyCalcs.filter((calc) => {
            return (
              dayjs().subtract(5, "day") > dayjs(calc["timestamp"]) &&
              dayjs(calc["timestamp"]) > dayjs().subtract(7, "day")
            );
          }).length,
        },
        {
          time: dayjs().subtract(5, "day").format("DD/MM/YYYY"),
          amount: onlyCalcs.filter((calc) => {
            return (
              dayjs().subtract(4, "day") > dayjs(calc["timestamp"]) &&
              dayjs(calc["timestamp"]) > dayjs().subtract(7, "day")
            );
          }).length,
        },
        {
          time: dayjs().subtract(4, "day").format("DD/MM/YYYY"),
          amount: onlyCalcs.filter((calc) => {
            return (
              dayjs().subtract(3, "day") > dayjs(calc["timestamp"]) &&
              dayjs(calc["timestamp"]) > dayjs().subtract(7, "day")
            );
          }).length,
        },
        {
          time: dayjs().subtract(3, "day").format("DD/MM/YYYY"),
          amount: onlyCalcs.filter((calc) => {
            return (
              dayjs().subtract(2, "day") > dayjs(calc["timestamp"]) &&
              dayjs(calc["timestamp"]) > dayjs().subtract(7, "day")
            );
          }).length,
        },
        {
          time: dayjs().subtract(2, "day").format("DD/MM/YYYY"),
          amount: onlyCalcs.filter((calc) => {
            return (
              dayjs().subtract(1, "day") > dayjs(calc["timestamp"]) &&
              dayjs(calc["timestamp"]) > dayjs().subtract(7, "day")
            );
          }).length,
        },
        {
          time: dayjs().subtract(1, "day").format("DD/MM/YYYY"),
          amount: onlyCalcs.filter((calc) => {
            return dayjs(calc["timestamp"]) > dayjs().subtract(7, "day");
          }).length,
        },
      ]);
    });
  }, []);

  return (
    <React.Fragment>
      <Title>Calculations this week</Title>
      <ResponsiveContainer>
        <LineChart
          data={calcs}
          margin={{
            top: 16,
            right: 16,
            bottom: 16,
            left: 24,
          }}
        >
          <XAxis
            dataKey="time"
            stroke={theme.palette.text.secondary}
            style={theme.typography.body2}
          >
            <Label
              position="bottom"
              style={{
                fill: theme.palette.text.primary,
                ...theme.typography.body1,
              }}
            >
              Date
            </Label>
          </XAxis>
          <YAxis
            stroke={theme.palette.text.secondary}
            style={theme.typography.body2}
          >
            <Label
              angle={270}
              position="left"
              style={{
                textAnchor: "middle",
                fill: theme.palette.text.primary,
                ...theme.typography.body1,
              }}
            >
              Calculations
            </Label>
          </YAxis>
          <Line
            isAnimationActive={false}
            type="monotone"
            dataKey="amount"
            stroke={theme.palette.primary.main}
            dot={true}
          />
        </LineChart>
      </ResponsiveContainer>
    </React.Fragment>
  );
}
